<template>
    <div>
        <Modal v-model="isshowRegist" :closable="false" :footer-hide="true" :mask-closable="false" class-name="sel_login_big">
            <div class="sel_login">
                <div class="title">{{$t('m.User_registration')}}</div>
                <span class="close" @click="close"></span>

                <div class="from">
                    <Input :clearable='true' type='email':autofocus='true' v-model="reEmail" class="sel_login_input" size="large" :placeholder="$t('m.email')" />
                    <Input :clearable='true' type='password' v-model="rePassword" class="sel_login_input" size="large" :placeholder="$t('m.password')" />
                    <Input :clearable='true' type='password' v-model="rePassword_t" class="sel_login_input" size="large" :placeholder="$t('m.repeatPassword')" />
                    <Input :clearable='true' v-model="reUsername" class="sel_login_input" size="large" :placeholder="$t('m.username')"/>
                </div>

                <div class="bottom_button">
                    <Button type="primary" size="large" @click="regist">{{$t('m.register')}}</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data(){
        return {
            reEmail:'',
            rePassword:'',
            rePassword_t:'',
            reUsername:'',
        }
    },
    methods:{
        //注册
        regist(){
            const vm = this;
            const resData = vm.Init('userMailboxRegistration');
            resData.mailbox = vm.reEmail;
            resData.password = vm.md5(vm.rePassword);
            resData.username = vm.reUsername;
            resData.uuid   = vm.userId;  //未登录用户id
            vm.yzInput(resData,(msg)=>{
                if(!msg){
                    vm.Req(resData,res=>{
                        if(res.ret=='1'){
                            // vm.isshowRegist = false;
                            vm.$store.setLoginAction(1,res.params)
                            vm.regi_succ()
                            vm.storageLocal(res.params);
                            vm.reEmail = '';
                            vm.rePassword = '';
                            vm.reUsername = '';
                            vm.rePassword_t = '';
                        }else{
                            vm.$Message.error(res.msg);
                        }
                    })      
                }else{
                    vm.$Message.error(msg);
                }
            })
        },
        //验证登录注册输入内容
        yzInput(obj,callback){
            const vm = this;
            if(!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(obj.mailbox)){
                callback(vm.$t('m.Email_incorrect'));
                return
            }
            if((vm.rePassword.length<6)||(vm.rePassword.length>16)){
                    callback(vm.$t('m.Password_incorrect'));
                    return
                }
                if(vm.rePassword!=vm.rePassword_t){
                    callback(vm.$t('m.Two_passwords_inconsistent'));
                    return
                }
                if((obj.username.length<2)||(obj.username.length>10)){
                    callback(vm.$t('m.User_name_inconsistent'));
                    return
                }
            callback(false)
        },
        //存储登录或注册时候的Local
        storageLocal(par){
            const vm = this;
            if(par){ //有传参数就是登录，否则就是退出
                localStorage['mailbox'] = par.mailbox; //邮箱
                localStorage['userName'] = par.userName; //用户名
                localStorage['type'] = par.type; //用户类型
                localStorage['customerId'] = par.customerId;   //用户id
                localStorage['createTime'] = par.createTime;  //创建时间
                if(par.userName){
                    vm.userName = par.userName;
                }
            }else{
                localStorage.removeItem('mailbox')
                localStorage.removeItem('userName')
                localStorage.removeItem('type')
                localStorage.removeItem('customerId')
                localStorage.removeItem('createTime')
                vm.userName = '';
            }
            
        }
    },
    props:{
        isshowRegist:{
            type:Boolean,
            default:false
        },
        regi_succ:{
            type:Function,
            default:()=>{}
        },
        close:{
            type:Function,
            default:()=>{}
        }
        
    }
}
</script>

<style>

</style>
